import { render, staticRenderFns } from "./InsureQRCode.vue?vue&type=template&id=72126d41&"
import script from "./InsureQRCode.vue?vue&type=script&lang=js&"
export * from "./InsureQRCode.vue?vue&type=script&lang=js&"
import style0 from "./InsureQRCode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports